import dayjs from "dayjs";
import dayjsutc from "dayjs/plugin/utc"; // dependent on utc plugin
import dayjstimezone from "dayjs/plugin/timezone";
dayjs.extend(dayjsutc);
dayjs.extend(dayjstimezone);
import moment from "moment";

export const JST = "Asia/Tokyo";
const TIMEZONE_OFFSET = "+09:00";
export const MONTH_DATE_FORMAT = "MM/DD";
export const YMD_FORMAT = "YYYY/MM/DD";

export function viewMonth2numeric(input?: string | null): number {
    const err = new Error(
        "年月の指定が正しくありません。YYYY/MMで入力してください。"
    );
    if (!input) throw err;
    try {
        const nums = input.split("/");
        if (nums.length != 2) {
            throw err;
        }
        const year = parseInt(nums[0], 10);
        const month = parseInt(nums[1], 10);
        if (isNaN(year) || isNaN(month)) {
            throw err;
        }
        return year * 100 + month;
    } catch (_) {}
    throw err;
}

export function numericMonth2view(yearmonth: number): string {
    return `${Math.floor(yearmonth / 100)}/${yearmonth % 100}`;
}

export function numericDate2view(date: number): string {
    return `${Math.floor(date / 10000)}/${Math.floor(date / 100) % 100}/${
        date % 100
    }`;
}

export function viewDate2numeric(input: string): number {
    const err = new Error("日付の指定が正しくありません。");
    if (!input) throw err;
    try {
        const nums = input.split("-");
        if (nums.length != 3) {
            throw err;
        }
        const year = parseInt(nums[0], 10);
        const month = parseInt(nums[1], 10);
        const day = parseInt(nums[2], 10);
        if (isNaN(year) || isNaN(month) || isNaN(day)) {
            throw err;
        }
        return year * 10000 + month * 100 + day;
    } catch (_) {}
    throw err;
}

export function iso2viewTime(isodate: string): string {
    return dayjs(isodate, JST).format("HH:mm");
}

export function currentYearmonth(): number {
    const now = dayjs(new Date()).tz(JST);
    return parseInt(now.format("YYYYMM"));
}

export function currentMonthStartEnd(): {
    start: number;
    end: number;
} {
    const now = dayjs(new Date()).tz(JST);
    const start = now.set("date", 1);
    const end = start.add(1, "month").add(-1, "day");
    return {
        start: parseInt(start.format("YYYYMMDD")),
        end: parseInt(end.format("YYYYMMDD")),
    };
}

// TODO: give this function a more descriptive name
export function convertRequestMonth(param: string): number {
    return parseInt(param.substr(0, 4)) * 1000 + parseInt(param.substr(4, 2));
}

export function currentMonth(): string {
    const now = dayjs(new Date()).tz(JST);
    return now.format("YYYY/MM");
}

export function currentMonthStartEndString(): {
    start: string;
    end: string;
} {
    const now = dayjs(new Date()).tz(JST);
    const start = now.set("date", 1);
    const end = start.add(1, "month").add(-1, "day");
    return {
        start: start.format("YYYY-MM-DD"),
        end: end.format("YYYY-MM-DD"),
    };
}

export function today(): string {
    return moment().utcOffset(TIMEZONE_OFFSET).format("YYYY-MM-DD");
}

export function yesterday(): string {
    return moment()
        .subtract(1, "days")
        .utcOffset(TIMEZONE_OFFSET)
        .format("YYYY-MM-DD");
}

export function yearmonth(yearmonth: number): string {
    const y = Math.floor(yearmonth / 100);
    const m = yearmonth % 100;
    return `${y}/${m}`;
}

export const dateToWeekYear = (date: string): any => {
    const t = moment(date).utcOffset(TIMEZONE_OFFSET);
    const yearNo = t.isoWeekYear();
    const weekNo = t.isoWeek();
    return { weekNo, yearNo };
};

export const weekYearToMonSun = (
    weekNo: number | null,
    yearNo: number | null,
    monFormat: string = MONTH_DATE_FORMAT,
    sunFormat: string = MONTH_DATE_FORMAT
): any => {
    if (!weekNo || !yearNo) {
        return {};
    }
    const mmt = moment().isoWeekYear(yearNo).isoWeek(weekNo);
    const mon = mmt.day("Monday").format(monFormat);
    const sun = mmt.day("Sunday").add(7, "days").format(sunFormat);
    return { mon, sun };
};

// TODO: remove 'any' on return type here
// add unit test
export const dateToMonSunWeekBounds = (
    date: string,
    monFormat: string = MONTH_DATE_FORMAT,
    sunFormat: string = MONTH_DATE_FORMAT
): any => {
    const { weekNo, yearNo } = dateToWeekYear(date);
    const { mon, sun } = weekYearToMonSun(weekNo, yearNo, monFormat, sunFormat);
    return { mon, sun };
};

export const convertUTCtoTimestamp = (date?: string): number => {
    if (!date) {
        return 0;
    }
    return parseInt(moment(date).format("X"));
};
